<template>
  <div>
    <div
      v-for="servicePromo in servicePromos"
      :key="servicePromo.id"
      class="ls-service-promos-bottom"
    >
      <div class="ls-service-promos-bottom--wrapper">
        <LsIcon
          type="thunder"
          color="primary"
          :size="screenSize.desktop ? 'sm' : 'xlg'"
          style="margin-right: 5px"
          class="ls-service-promos-bottom--icon"
        />
        <div class="header-text">
          <h4 class="header-text--top">
            Seasonal Recommendation - {{ servicePromo.service.name }}
          </h4>
          <p class="header-text--description">{{ servicePromo.service.promo_description }}</p>
        </div>
      </div>
      <LsButton
        class="ls-service-promos-bottom--button"
        :text="servicePromo.service.promo_cta"
        bg-color="primary"
        text-color="white"
        track-id="ls_service_promos_bottom-cta"
        test-id="cta"
        @click="onClick(servicePromo)"
      />
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import { mapState } from 'vuex';
import { LsButton, LsIcon } from '@/components/common';

export default {
  name: 'LsServicePromosBottom',
  components: {
    LsButton,
    LsIcon,
  },
  props: {
    propertyId: VueTypes.number.isRequired,
    servicePromos: VueTypes.arrayOf(
      VueTypes.shape({
        id: VueTypes.number.isRequired,
        service: VueTypes.shape({
          id: VueTypes.number.isRequired,
          name: VueTypes.string.isRequired,
          promo_description: VueTypes.string.isRequired,
          promo_cta: VueTypes.string.isRequired,
        }).isRequired.loose,
      }).isRequired.loose
    ),
  },
  computed: {
    ...mapState(['screenSize']),
  },
  methods: {
    onClick(servicePromo) {
      const { service, id } = servicePromo;

      this.$router.push({
        name:
          service.str_id === 'fertilization' || service.str_id === 'aeration'
            ? 'orderPricedServiceForm'
            : 'orderServiceForm',
        params: {
          property_id: this.propertyId,
          str_id: service.str_id,
          service_id: service.id,
          service_promo_id: id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ls-service-promos-bottom {
  padding: 18px;
  margin: 10px 0;
  background: $primary-light;
  display: flex;
  flex-wrap: wrap;
}

.ls-service-promos-bottom--button {
  margin-left: auto;

  @media (max-width: $mobile-max-width) {
    margin-top: 20px;
  }
}

.ls-service-promos-bottom--wrapper {
  position: relative;
  font-size: $size-5;
  padding-bottom: 6px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  .header-text--top {
    display: flex;
    font-size: $size-4;
    align-items: center;
    padding-right: 4px;
    font-weight: 700;
  }

  .header-text {
    @media (min-width: $desktop) {
      max-width: 370px;
    }
  }
}
.themed-app {
  .ls-service-promos-bottom {
    background: $theme-color-primary-light;
  }
  .ls-service-promos-bottom--wrapper {
    font-size: $theme-txt-body;
    .header-text--top {
      font-size: $theme-txt-body-lg;
    }
  }
}
</style>
